"use client";

import { motion } from "framer-motion";
import { searchHeaderVariants } from "@/lib/animations";
import MainSearchBar from "@/components/search/MainSearchBar";
import type { SearchField } from "@/types/product-search";

export interface TourSearchBarSkeletonProps {
    productType?: string;
    searchFields?: SearchField[];
    onSearch?: (filters: Record<string, any>) => void;
    isLoading?: boolean;
}

export default function TourSearchBarSkeleton({
    productType = 'tour',
    searchFields = [],
    onSearch,
    isLoading = false,
}: TourSearchBarSkeletonProps) {
    return (
        <motion.div 
            className="w-full lg:w-8/12 mx-auto px-4 lg:px-0"
            variants={searchHeaderVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
        >
            <div className="w-full bg-alsero-soft-white rounded-2xl -mt-1/2 -translate-y-1/2 shadow-search-bar">
                <div className="px-6 py-5">
                    <MainSearchBar
                        productType={productType}
                        searchFields={searchFields}
                        onSearch={onSearch}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </motion.div>
    )
}